import * as React from "react"

const RoundedCheckWithBackground = (props: any) => (
    <svg width={80} height={80} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx={40} cy={40} r={40} fill="#4D3951" fillOpacity={0.2} />
        <circle cx={40} cy={40} r={24} fill="#4D3951" />
        <path
            d="m52.165 34.914-13 13a1.995 1.995 0 0 1-2.828 0l-6.5-6.5a1.997 1.997 0 0 1 0-2.828 1.997 1.997 0 0 1 2.828 0l5.086 5.086 11.586-11.586a1.997 1.997 0 0 1 2.828 0 1.998 1.998 0 0 1 0 2.828Z"
            fill="#FAFAFA"
        />
    </svg>
)

export default RoundedCheckWithBackground
